// FearGreedSegmentCalculator.js
// Static class — Noun.Verb methods for segment lookups (Development.Patterns rk=a786510f).
import fearGreedConst from './fearGreedConst';

class FearGreedSegmentCalculator {
    /**
     * @param {number} value - 0-100
     * @returns {{max:number,label:string,shortLabel:string,color:string,icon:string}}
     */
    static getSegment(value) {
        const segments = fearGreedConst.SEGMENTS;
        return segments.find((s) => value < s.max) ?? segments[segments.length - 1];
    }

    /**
     * @param {number} blockIndex
     * @param {number} blockCount
     * @returns {string} color for that block's position on the scale
     */
    static getBlockColor(blockIndex, blockCount) {
        const pct = (blockIndex / blockCount) * 100;
        return FearGreedSegmentCalculator.getSegment(pct).color;
    }
}

export default FearGreedSegmentCalculator;
